<template>
  <div>
    <v-container v-if="section_info.course_id" fluid>
      <v-card flat tile>
        <v-card class="d-flex mb-6" flat tile>
          <v-btn fab text small color="grey darken-2" @click="stepDown">
            <v-icon large dense> mdi-chevron-left </v-icon>
          </v-btn>
          <v-text-field
            type="number"
            v-model="showColumns"
            hint="Show number of entries in gradebook"
            persistent-hint
            class="shrink"
          ></v-text-field>
          <v-btn fab text small color="grey darken-2" @click="stepUp">
            <v-icon large dense> mdi-chevron-right </v-icon>
          </v-btn>
        </v-card>
        <v-simple-table
          class="align-start overflow-x: scroll"
          fixed-header
          height="100%"
          dense
        >
          <thead>
            <tr>
              <th></th>
              <th></th>
              <th
                class="text-center"
                v-for="assessment in sortedAssessments"
                :key="assessment.id"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <span v-if="assessment.name.length > 21">
                        {{ assessment.name.substr(0, 9) }} ...
                        {{ assessment.name.substr(-9) }}
                      </span>
                      <span v-else>
                        {{ assessment.name }}
                      </span>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon small v-bind="attrs" v-on="on">
                            mdi-dots-vertical
                          </v-icon>
                        </template>
                        <v-list dense>
                          <v-list-item dense>
                            <v-list-item-icon class="mx-1">
                              <v-icon
                                small
                                dense
                                @click="editAssessment(assessment)"
                              >
                                mdi-pencil
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-subtitle> Edit</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item dense>
                            <v-list-item-icon class="mx-1">
                              <v-icon
                                dense
                                small
                                @click="deleteAssessment(assessment)"
                              >
                                mdi-trash-can
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-subtitle> Remove</v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                  <span class="text-align: center"
                    >{{ assessment.name }} <br />
                    {{ assessment.type.split(" (")[0] }} ({{
                      assessment.weight
                    }})</span
                  >
                </v-tooltip>
              </th>
            </tr>
            <tr>
              <th>
                <v-list-item class="px-2">
                  <v-list-item-icon>
                    <v-icon color="secondary"> mdi-account-multiple </v-icon>
                  </v-list-item-icon>

                  <v-list-item-title>Class Average</v-list-item-title>
                </v-list-item>
              </th>
              <th>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">
                      <v-dialog v-model="dialog" max-width="600px" scrollable>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon color="primary" v-bind="attrs" v-on="on">
                            <v-icon @click="newAssessment()"
                              >mdi-plus-circle</v-icon
                            >
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title>
                            <span class="headline">{{ dialogLabel }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-form ref="form" v-model="valid">
                                <v-row>
                                  <v-col cols="12" md="8" sm="8" lg="8">
                                    <v-text-field
                                      v-model="assessment.name"
                                      label="Name"
                                      :rules="inputRules"
                                    ></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="4" md="4" lg="4">
                                    <v-menu
                                      v-model="menu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-text-field
                                          :value="
                                            new Date(
                                              assessment.date
                                            ).toLocaleDateString()
                                          "
                                          label="Assigned Date"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                          @focus="
                                            datePicker = assessment.date.substr(
                                              0,
                                              10
                                            )
                                          "
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="datePicker"
                                        @input="menu = false; assessment.date = $parseDate(datePicker)"
                                      ></v-date-picker>
                                    </v-menu>
                                  </v-col>
                                  <v-col cols="12" sm="8" md="8">
                                    <v-select
                                      v-model="assessment.type"
                                      :items="assessmentTypes"
                                      item-text="type"
                                      return-object
                                      label="Type"
                                      :rules="rules.type"
                                      @change="sliderValueUpdate()"
                                    ></v-select>
                                  </v-col>

                                  <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                      :rules="
                                        topScore
                                          ? rules.assessMax(topScore)
                                          : inputRules
                                      "
                                      v-model="assessment.possible"
                                      label="Max Possible"
                                      hint="Max points a student can get"
                                    ></v-text-field>
                                  </v-col>

                                  <v-col cols="12" sm="12" md="12">
                                    <v-slider
                                      v-if="assessment.type"
                                      :rules="rules.slider"
                                      class="mt-3"
                                      :label="`Weight (${assessment.weight})`"
                                      v-model="assessment.weight"
                                      :thumb-size="30"
                                      thumb-label="always"
                                      max="35"
                                      min="0"
                                    >
                                    </v-slider>
                                    <v-slider
                                      v-else
                                      :disabled="true"
                                      class="mt-3"
                                      :thumb-size="30"
                                      label="Weight"
                                      thumb-label="always"
                                      max="35"
                                      min="0"
                                    ></v-slider>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-textarea
                                      label="Description"
                                      v-model="assessment.description"
                                      outlined
                                    ></v-textarea>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12">
                                    <v-select
                                      class="mt-6"
                                      v-model="selectedSections"
                                      :items="sections"
                                      item-text="section"
                                      item-value="id"
                                      label="Also copy to sections"
                                      multiple
                                      chips
                                    ></v-select>
                                  </v-col>
                                </v-row>
                              </v-form>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="dialog = false"
                            >
                              Close
                            </v-btn>
                            <v-btn
                              :disabled="!valid"
                              color="blue darken-1"
                              text
                              @click="saveAssessment()"
                            >
                              Save
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </div>
                  </template>
                  <span>Add new gradebook entry</span>
                </v-tooltip>
              </th>
              <th
                class="text-center"
                v-for="assessment in sortedAssessments"
                :key="assessment.id"
              >
                <span>
                  <span
                    :style="
                      assessmentAvg(assessment.id) / assessment.possible > 0.5
                        ? 'color: green'
                        : 'color: #a01919'
                    "
                    >{{ assessmentAvg(assessment.id) }}
                  </span>
                  / {{ assessment.possible }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="student in section.students" :key="student.id">
              <th>
                <v-list-item class="px-2">
                  <v-list-item-avatar>
                    <v-img :src="student.portrait_img"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-title>
                    {{ student.full_name_2 }}
                  </v-list-item-title>
                </v-list-item>
              </th>
              <th>
                <v-card
                  outlined
                  class="ma-0 px-0"
                  elevation="3"
                  dense
                  height="100%"
                  min-width="75"
                >
                  <v-card-text>
                    <v-btn icon @click="viewCalculation(student)">
                      {{
                        student.avgs.find(
                          (data) => data.grading_period_id == grading_period.id
                        ).avg
                      }}
                    </v-btn>
                    <v-btn
                      small
                      icon
                      v-if="
                        transferred.filter((t) => t.user_id == student.id)
                          .length > 0
                      "
                      @click="viewTransfers(student)"
                    >
                      <v-icon small> mdi-transfer </v-icon>
                    </v-btn>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on">
                          mdi-dots-vertical
                        </v-icon>
                      </template>
                      <v-simple-table>
                        <thead>
                          <tr>
                            <th>
                              <v-btn icon @click="getComments(student)">
                                <v-icon small> mdi-chat </v-icon>
                              </v-btn>
                            </th>
                            <th v-for="gp in grading_periods" :key="gp.id">
                              {{ gp.name }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td></td>
                            <td v-for="gp in grading_periods" :key="gp.id">
                              {{
                                student.avgs.find(
                                  (data) => data.grading_period_id == gp.id
                                ).avg
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-menu>
                  </v-card-text>
                </v-card>
              </th>
              <td
                v-for="assessment in sortedAssessments"
                :key="assessment.id"
                class="pa-0"
                align="center"
              >
                <v-card
                  outlined
                  max-width="100"
                  height="100%"
                  v-if="activeGrading == assessment.id + '-' + student.id"
                >
                  <v-card-text class="pa-0">
                    <v-text-field
                      @blur="processGrading(student, assessment)"
                      @keydown="keyhandler($event, student, assessment)"
                      autofocus
                      style="color: gray"
                      autocomplete="off"
                      dense
                      :class="scoreStyle(student, assessment)"
                      class="mx-3"
                      type="number"
                      :rules="rules.gradeMax(assessment.possible)"
                      v-model="newScore"
                      @focus="newScore = getScore(student, assessment)"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
                <v-card
                  outlined
                  max-width="100"
                  height="100%"
                  v-else
                  @click="activeGrading = assessment.id + '-' + student.id"
                >
                  <v-hover v-slot="{ hover }">
                    <v-card-text
                      :class="scoreStyle(student, assessment)"
                      class="pa-0"
                    >
                      {{
                        getScore(student, assessment) === ""
                          ? "--"
                          : getScore(student, assessment)
                      }}
                      <v-icon
                        v-if="hover || getNote(student, assessment).length > 0"
                        @click="addNote(student, assessment)"
                      >
                        mdi-flag
                      </v-icon>
                    </v-card-text>
                  </v-hover>
                </v-card>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-container>
    <div class="text-center">
      <v-snackbar v-model="snackbar" :multi-line="true">
        {{ snackbarMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
    <v-dialog v-model="noteDialog" max-width="600px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Gradebook Notes</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-textarea v-model="note" label="Notes"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-checkbox v-model="excluded" label="Excluded"> </v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn color="blue darken-1" text @click="noteDialog = false">
                  Close
                </v-btn>
                <v-btn color="primary" @click="saveNotes"> Save </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="commentsDialog" max-width="900px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Comments</span>
          <v-spacer />
          <v-btn icon @click="commentsDialog = false">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-card flat tile v-for="comment in comments" :key="comment.id">
              {{ new Date(comment.created_at).toLocaleDateString() }}
              {{ comment.text }}
              <v-btn icon
                ><v-icon small color="red" @click="deleteComment(comment.id)"
                  >mdi-close</v-icon
                ></v-btn
              >
            </v-card>
            <v-textarea
              v-model="newComment"
              label="New Comment"
            >
            </v-textarea>
            <v-select
              v-model="selectedComment"
              :items="commentsList"
              label="Add to the comment"
            >
            </v-select>
            <v-card-actions>
              <v-btn color="primary" @click="saveComment">Save</v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="calculationsDialog" max-width="900px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Gradebook Entry Calculations</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-card flat tile>
              <student-gradebook-table
                v-if="calculation.scores.length > 0"
                :scores="calculation.scores"
                :average="calculation.average"
              >
              </student-gradebook-table>
            </v-card>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transfersDialog" max-width="900px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">Gradebook Entry Transfers</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-simple-table>
              <thead>
                <th>Date</th>
                <th>Section</th>
                <th>Entry Name</th>
                <th>Entry Type</th>
                <th>Weight</th>
                <th>Score</th>
              </thead>
              <tbody>
                <tr v-for="(transfer, id) in studentsTransfers" :key="id">
                  <td>{{ new Date(transfer.date).toLocaleDateString() }}</td>
                  <td>{{ transfer.course.split("Section ")[1] }}</td>
                  <td>{{ transfer.name }}</td>
                  <td>{{ transfer.type.split(" (")[0] }}</td>
                  <td>{{ transfer.weight }}</td>
                  <td>{{ transfer.score }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import StudentGradebookTable from "./StudentGradebookTable.vue";

export default {
  components: { StudentGradebookTable },
  props: {
    section_info: {
      type: Object,
      required: true,
    },
    grading_period: {
      type: Object,
      required: true,
    },
    grading_periods: {
      type: Array,
      required: true,
    },
  },
  watch: {
    section_info: "getSectionAssessments",
    selectedComment: "appendComment",
  },
  data: () => ({
    datePicker: null,
    snackbar: false,
    snackbarMessage: "",
    activeGrading: "",
    newScore: null,
    note: "",
    excluded: false,
    calculationsDialog: false,
    calculation: {
      scores: [],
      average: "N/A",
    },
    transfersDialog: false,
    studentsTransfers: [],
    noteDialog: false,
    gradeForNote: {},
    start: 0,
    end: 0,
    showColumns: 5,
    isFocus: false,
    topScore: null,
    deleteWarning: false,
    valid: false,
    inputRules: [(v) => !!v || "Required"],
    scoreHint: "",
    dialogLabel: null,
    dialog: false,
    menu: false,
    modal: false,
    assessmentTypes: [
      { min: 1, max: 5, type: "Participation (1-5)" },
      { min: 1, max: 10, type: "Homework (1-10)" },
      { min: 1, max: 10, type: "Classwork (1-10)" },
      { min: 10, max: 20, type: "Independent Assignments (10-20)" },
      { min: 10, max: 20, type: "Minor Assignments (10-20)" },
      { min: 15, max: 25, type: "Major Assignments (15-25)" },
      { min: 25, max: 35, type: "Benchmark Assessment (25-35)" },
    ],
    editedAssessmentId: null,
    assessment: {
      name: null,
      date: null,
      type: null,
      possible: 100,
      weight: 0,
      description: null,
    },
    section: {
      assessments: [],
      students: [],
    },
    grades: [],
    transferred: [],
    commentsDialog: false,
    newComment: "",
    selectedComment: "",
    commentsList: [
      "A pleasure to have in class",
      "Online classwork is complete and turned in on time",
      "Regularly participates in online classes, discussions, and learning activities",
      "Does not regularly attend live online zoom classes",
      "Usually late to live online zoom classes",
      "Participation and attention during live online zoom classes is unsatisfactory",
      "Online classwork is not completed or turned in",
      "Does not answer questions when called on in live online zoom classes",
      "Online learning guidelines during live zoom classes are not being followed",
      "In Danger of Failing",
      "Parent teacher conference requested",
      "Actual grade below 50",
      "Improved effort",
      "Talkative and/or disruptive",
      "Homework not handed in",
      "Frequently tardy",
      "Frequently absent",
      "Grade reflects poor test scores",
      "Unsatisfactory or no project work",
      "Unsatisfactory participation",
    ],
    studentToComment: 0,
    comments: [],
    sections: [],
    selectedSections: [],
  }),
  computed: {
    sortedAssessments() {
      return this.section.assessments
        .filter(
          (a) =>
            new Date(a.date) <= new Date(this.grading_period.end_date) &&
            new Date(a.date) >= new Date(this.grading_period.start_date)
        )
        .sort((a, b) => {
          let da = new Date(a.date.substr(0, 10)),
            db = new Date(b.date.substr(0, 10));
          return db - da;
        })
        .slice(this.start, Number(this.showColumns) + this.end);
    },
    rules() {
      return {
        slider: [
          (v) =>
            v <= this.assessment.type.max ||
            `Too High for ${this.assessment.type.type} Max is ${this.assessment.type.max}`,
          (v) =>
            v >= this.assessment.type.min ||
            `Too Low for ${this.assessment.type.type} Min is ${this.assessment.type.min}`,
        ],
        type: [(v) => !!v || "Required"],
        gradeMax(max) {
          return [
            (v) => v <= max || `Max is ${max}`,
            (v) => v > -1 || `Cannot be negative`,
          ];
        },
        assessMax(max) {
          return [
            (v) => v >= max || `Can't be lower than max given score of ${max}`,
            (v) => !!v || "Required",
          ];
        },
      };
    },
  },
  methods: {
    appendComment() {
      if (this.selectedComment !== 0)
        this.newComment += this.selectedComment +  " "
      this.selectedComment = 0
    },
    getComments(student) {
      this.$sisApi("get", `my-schedule/student-comments`, {
        user_id: student.id,
        section_id: this.section_info.section_id,
      })
        .then((response) => {
          this.commentsDialog = true;
          this.comments = response.data;
          this.studentToComment = student.id;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveComment() {
      this.$sisApi("post", `my-schedule/student-comment`, {
        user_id: this.studentToComment,
        section_id: this.section_info.section_id,
        text: this.newComment,
      })
        .then((response) => {
          this.newComment = ""
          this.selectedComment = 0
          this.comments.push(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteComment(cid) {
      this.$sisApi("delete", `my-schedule/student-comment/${cid}`)
        .then(() => {
          let index = this.comments.findIndex((c) => c.id == cid);
          this.comments.splice(index, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    viewTransfers(student) {
      this.transfersDialog = true;
      this.studentsTransfers = this.transferred.filter(
        (t) => t.user_id == student.id
      );
    },
    viewCalculation(student) {
      this.calculation = {
        scores: [],
        average: "N/A",
      };
      this.calculationsDialog = true;
      this.$sisApi(
        "get",
        `my-schedule/students-course-gradebook/${student.id}/${this.section_info.section_id}`,
        {
          start_date: this.grading_period.start_date,
          end_date: this.grading_period.end_date,
        }
      )
        .then((response) => {
          this.calculation.scores = response.data.filter((s) => s.id > 0);
          this.calculation.average = response.data.find((s) => s.id == 0).avg;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getScore(student, assessment) {
      let index = this.grades.findIndex(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      return index < 0 ? "" : this.grades[index].score;
    },
    getNote(student, assessment) {
      let index = this.grades.findIndex(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      return index < 0 ? "" : this.grades[index].note;
    },
    getExcluded(student, assessment) {
      let index = this.grades.findIndex(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      return index < 0 ? 0 : this.grades[index].excluded;
    },
    scoreStyle(student, assessment) {
      let classes = [];
      let gr = this.grades.find(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      classes.push(
        gr.score / assessment.possible > 0.64 ? "inputGrade" : "inputGradeLow"
      );
      if (gr.note.length > 0) {
        classes.push("noted");
      }
      if (gr.excluded == 1) {
        classes.push("exclude");
      }
      return classes.join(" ");
    },
    saveNotes() {
      this.gradeForNote.note = this.note;
      this.gradeForNote.excluded = this.excluded ? 'yes' : 'no';
      this.$sisApi("post", `my-schedule/grade`, this.gradeForNote)
        .then((response) => {
          this.section.students.find(
            (s) => s.id == this.gradeForNote.user_id
          ).avgs = response.data;
          this.gradeForNote = {};
          this.noteDialog = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addNote(student, assessment) {
      this.note = this.getNote(student, assessment);
      this.excluded = this.getExcluded(student, assessment);
      this.gradeForNote = this.grades.find(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      this.noteDialog = true;
    },
    getSectionAssessments() {
      this.$sisApi("get", `my-schedule/gradebook`, {
        course_id: this.section_info.course_id,
        section: this.section_info.section_name,
      })
        .then((response) => {
          this.section.assessments = response.data.assessments;
          this.section.students = response.data.students;
          this.grades = response.data.scores;
          this.transferred = response.data.transferred;
          this.sections = response.data.sections;
          // remove current section from options
          let index = this.sections.findIndex(
            (s) => s.id == this.section_info.section_id
          );
          this.sections.splice(index, 1);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    stepDown() {
      if (this.start > 0) {
        this.start = this.start - 1;
        this.end = this.end - 1;
      }
    },
    stepUp() {
      let length = this.section.assessments.length;
      if (length > Number(this.showColumns) + this.end) {
        this.start = this.start + 1;
        this.end = this.end + 1;
      }
    },
    keyhandler(event, student, assessment) {
      if (
        ["Enter", "ArrowDown", "ArrowUp", "ArrowRight", "ArrowLeft"].findIndex(
          (k) => k == event.key
        ) < 0
      ) {
        return;
      }
      let grade = this.grades.find(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      let col = this.section.assessments.findIndex(
        (a) => a.id == assessment.id
      );
      let row = this.section.students.findIndex((s) => s.id == student.id);
      if (event.key == "Enter" || event.key == "ArrowDown") {
        row += 1;
      }
      if (event.key == "ArrowUp") {
        row -= 1;
      }
      if (event.key == "ArrowRight") {
        col += 1;
      }
      if (event.key == "ArrowLeft") {
        col -= 1;
      }
      if (
        col < 0 ||
        row < 0 ||
        this.section.students.length == row // prevent decreasing the score in last row
      ) {
        event.preventDefault();
        return;
      }
      this.activeGrading = [
        this.section.assessments[col].id,
        this.section.students[row].id,
      ].join("-");
      if (this.newScore !== grade.score) {
        this.postGrade(assessment, student);
      }
    },
    processGrading(student, assessment) {
      let grade = this.grades.find(
        (grade) =>
          grade.user_id == student.id && grade.assessment_id == assessment.id
      );
      if (this.newScore !== grade.score) {
        this.postGrade(assessment, student);
        this.activeGrading = "";
      }
    },
    assessmentAvg(id) {
      let a = this.grades
        .filter(
          (g) => g.assessment_id == id && g.score !== "" && g.score != null
        )
        .map((g) => g.score);
      if (a.length == 0) return "";
      return Math.round(
        a.reduce((sum, val) => sum + parseFloat(val), 0) / a.length
      );
    },
    sliderValueUpdate() {
      this.assessment.weight = this.assessment.type.min;
    },
    editAssessment(assessment) {
      this.dialogLabel = "Edit Gradebook Entry";
      this.assessment.name = assessment.name;
      this.assessment.date = assessment.date;
      this.assessment.type = this.assessmentTypes.find(
        (a) => a.type == assessment.type
      );
      this.assessment.possible = assessment.possible;
      this.assessment.weight = assessment.weight;
      this.assessment.description = assessment.description;

      this.topScore = Math.max(
        ...this.grades
          .filter((grade) => grade.assessment_id === assessment.id)
          .map((o) => o.score),
        0
      );
      this.editedAssessmentId = assessment.id;
      this.dialog = true;
    },
    deleteAssessment(assessment) {
      let num = this.grades.filter(
        (grade) => grade.assessment_id == assessment.id && grade.score != ""
      ).length;
      if (num == 0) {
        this.$sisApi("delete", `my-schedule/assessment/${assessment.id}`).then(
          () => {
            let index = this.section.assessments.findIndex(
              (a) => a.id == assessment.id
            );
            this.section.assessments.splice(index, 1);
          }
        );
      } else {
        this.snackbar = true;
        this.snackbarMessage = "Gradebook entries with grades can't be deleted";
      }
    },
    newAssessment() {
      this.editedAssessmentId = null;
      this.dialogLabel = "New Gradebook Entry";
      this.assessment.name = null;
      this.assessment.date = this.$today();
      this.assessment.type = null;
      this.assessment.possible = 100;
      this.assessment.weight = 0;
      this.assessment.description = null;
      this.topScore = null;
    },
    saveAssessment() {
      const editedAssess = this.assessment;
      editedAssess.type = editedAssess.type.type;
      if (!this.editedAssessmentId) {
        this.$sisApi(
          "post",
          `my-schedule/assessment/${this.section_info.section_id}`,
          { ...editedAssess, sections: this.selectedSections }
        )
          .then((response) => {
            this.section.assessments.push(response.data);
            this.section.students.forEach((student) => {
              this.grades.push({
                section_id: this.section_info.section_id,
                assessment_id: response.data.id,
                user_id: student.id,
                excluded: 0,
                score: "",
                note: "",
              });
            });
          })
          .catch((error) => {
            this.snackbar = true;
            this.snackbarMessage = error.response.data.message;
          });
      } else {
        this.$sisApi(
          "patch",
          `my-schedule/assessment/${this.editedAssessmentId}`,
          editedAssess
        )
          .then(() => {
            const ind = this.section.assessments.findIndex(
              (a) => a.id === this.editedAssessmentId
            );
            this.section.assessments[ind].name = editedAssess.name;
            this.section.assessments[ind].date = editedAssess.date;
            this.section.assessments[ind].type = editedAssess.type.type;
            this.section.assessments[ind].possible = editedAssess.possible;
            this.section.assessments[ind].weight = editedAssess.weight;
            this.section.assessments[ind].description =
              editedAssess.description;
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.dialog = false;
    },
    postGrade(assessment, student) {
      let grade = this.grades.find(
        (g) => g.user_id == student.id && g.assessment_id == assessment.id
      );
      if (parseFloat(this.newScore) > parseFloat(assessment.possible)) {
        this.newScore = assessment.possible;
      }
      let prev = grade.score;
      grade.score = this.newScore;
      this.$sisApi("post", `my-schedule/grade`, grade)
        .then((response) => {
          let index = this.section.students.findIndex(
            (s) => s.id == grade.user_id
          );
          this.section.students[index].avgs = response.data;
        })
        .catch((error) => {
          console.log(error);
          grade.score = prev;
          this.snackbar = true;
          this.snackbarMessage = "The score is not updated";
        });
    },
  },
  mounted() {
    if (this.section_info.course_id) {
      this.getSectionAssessments();
    }
    this.allowed = true;
  },
};
</script>
<style scoped>
.inputGradeLow,
.inputGrade {
  font-size: 1.2em;
}
.exclude,
.exclude >>> .v-text-field__slot input {
  text-decoration: line-through;
}
.inputGradeLow,
.inputGradeLow >>> .v-text-field__slot input {
  color: rgb(160, 25, 25) !important;
  font-weight: bold;
  text-align: center;
}
.noted,
.noted >>> .v-text-field__slot input {
  font-style: italic;
}
.inputGrade,
.inputGrade >>> .v-text-field__slot input {
  color: rgb(49, 139, 8) !important;
  font-weight: bold;
  text-align: center;
}

.inputGrade >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputGrade >>> input::-webkit-outer-spin-button,
.inputGrade >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
